@if (mode === 'date-picker') {
    <mat-datepicker #datepicker [calendarHeaderComponent]="CustomCalendarHeaderComponent"
                    (viewChanged)="currentViewChanged($event)">
        @if (showPickerActions && currentView === 'month') {
            <mat-datepicker-actions class="w-100" fxLayoutAlign="start start">
                <ng-content select="[DatePickerActions]"></ng-content>
            </mat-datepicker-actions>
        }
    </mat-datepicker>
}
@if (mode === 'date-range-picker') {
    <mat-date-range-input [rangePicker]="picker" (click)="openClickListener.emit()"
                          [min]="minDate"
                          [max]="maxDate"
                          [dateFilter]="monthLockFilter"
                          class="d-none">
        <input matStartDate placeholder="Start date"
               [formControl]="dateStartControl">
        <input matEndDate placeholder="End date"
               [formControl]="dateEndControl">
    </mat-date-range-input>
    <mat-date-range-picker #picker
                           [dateClass]="dateClass"
                           (closed)="closed.emit()"
                           [disabled]="disabled"
                           [calendarHeaderComponent]="CustomCalendarHeaderComponent"
                           (viewChanged)="currentViewChanged($event)">
        @if (showPickerActions && currentView === 'month') {
            <mat-date-range-picker-actions class="w-100" fxLayoutAlign="start start">
                <ng-content select="[PickerActions]"></ng-content>
            </mat-date-range-picker-actions>
        }
    </mat-date-range-picker>
}
